export default __webpack_public_path__ + "4aba0d07200b16799b6f2d1639a6a55d.png";